import { ActionType } from '../../controllers/ActionsGenerator';
import { FooterType } from '../../controllers/FooterGenerator';
import { IllustrationType } from '../../controllers/IllustrationGenerator';
import { InsurancePageName } from '../../helpers/insuranceHelpers';

export const therapySchema = (routedFromProfilePage: boolean, t, session) => ({
    [InsurancePageName.InsuranceApproved]: {
        illustrationType: IllustrationType.APPROVED,
        heading: t('insuranceForm:insurance_approved.page_title'),
        actionSchema: [
            {
                title: t(
                    routedFromProfilePage
                        ? 'translation:common.backToProfile'
                        : 'insuranceForm:insurance_approved.back_home',
                ),
                onClick: ActionType.GO_HOME_OR_PROFILE,
            },
            {
                title: t(`insuranceForm:insurance_approved.${session ? 'review' : 'book'}_session`),
                onClick: ActionType.GO_EXTEND_THERAPY,
            },
        ],
        footer: FooterType.CONTACT_US_BOX,
    },
    [InsurancePageName.InsuranceIneligible]: {
        illustrationType: IllustrationType.INELIGIBLE,
        heading: t('insuranceForm:insurance_ineligible.title'),
        actionSchema: [
            {
                title: t('insuranceForm:insurance_ineligible.explore_care'),
                onClick: ActionType.GO_RESOURCES,
            },
            {
                title: t('insuranceForm:insurance_ineligible.connect_therapist'),
                onClick: ActionType.GO_MESSAGES,
            },
            ...(routedFromProfilePage
                ? [
                      {
                          title: t('translation:common.backToProfile'),
                          onClick: ActionType.GO_HOME_OR_PROFILE,
                      },
                  ]
                : []),
        ],
        footer: FooterType.INELIGIBLE_CONTACT_US_BOX,
    },
    [InsurancePageName.InsuranceInactive]: {
        illustrationType: IllustrationType.INACTIVE,
        titleAlignment: 'start' as const,
        heading: t('insuranceForm:insurance_inactive.title'),
        actionSchema: [
            {
                title: t('insuranceForm:insurance_inactive.check_eligibility'),
                onClick: ActionType.GO_INSURANCE_FORM,
            },
            {
                title: t('insuranceForm:insurance_inactive.connect_therapist'),
                onClick: ActionType.GO_MESSAGES,
            },
            {
                title: t(
                    routedFromProfilePage
                        ? 'translation:common.backToProfile'
                        : 'insuranceForm:insurance_approved.back_home',
                ),
                onClick: ActionType.GO_HOME_OR_PROFILE,
            },
        ],
        footer: FooterType.INELIGIBLE_CONTACT_US_BOX,
    },
    [InsurancePageName.InsuranceError]: {
        illustrationType: IllustrationType.ERROR,
        heading: t('insuranceForm:insurance_error.title'),
        actionSchema: [
            {
                title: t('insuranceForm:insurance_error.check_eligibility'),
                onClick: ActionType.GO_INSURANCE_FORM,
            },
        ],
    },
});
